<template>
  <div class="zoom-container"
       :style="{ width: containerWidth + 'px', height: containerHeight + 'px' }"
       @mousemove="handleMove"
       @touchmove="handleMove"
       @mouseleave="handleLeave">
    <div class="zoomed-image" :style="{ backgroundImage: 'url(' + src + ')', transform: 'rotate(' + rotation + 'deg)' }" />
  </div>
</template>

<script>
export default {
  name: 'RegZoomImage',
  props: {
    maxImageWidth: {
      type: Number,
      required: true
    },
    maxImageHeight: {
      type: Number,
      required: true
    },
    containerWidth: {
      type: Number,
      required: true
    },
    containerHeight: {
      type: Number,
      required: true
    },
    zoomPercent: {
      type: Number,
      default: 25
    },
    rotation: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      required: true
    }
  },
  methods: {
    handleMove(e) {
      const rect = this.$el.getBoundingClientRect()
      const containerWidth = this.$el.clientWidth
      const containerHeight = this.$el.clientHeight

      // Mouse coordinates relative to the container
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top

      // Center of the container
      const centerX = containerWidth / 2
      const centerY = containerHeight / 2

      // Adjusted coordinates based on rotation
      const rotatedX = (x - centerX) * Math.cos((this.rotation * Math.PI) / 180) - (y - centerY) * Math.sin((this.rotation * Math.PI) / 180) + centerX
      const rotatedY = (x - centerX) * Math.sin((this.rotation * Math.PI) / 180) + (y - centerY) * Math.cos((this.rotation * Math.PI) / 180) + centerY

      // Calculate percentages
      const percentX = (rotatedX / containerWidth) * 100
      const percentY = (rotatedY / containerHeight) * 100

      const swapDimensions = (this.rotation / 90) % 2 !== 0
      const effectiveContainerWidth = swapDimensions ? this.maxImageHeight : this.maxImageWidth
      const effectiveContainerHeight = swapDimensions ? this.maxImageWidth : this.maxImageHeight

      // Scale percentages based on image size and zoom percent
      const scaledZoom = this.zoomPercent / 100
      const scaleX = (effectiveContainerWidth * scaledZoom / containerWidth) * 100
      const scaleY = (effectiveContainerHeight * scaledZoom / containerHeight) * 100

      this.$el.querySelector('.zoomed-image').style.backgroundSize = `${scaleX}% ${scaleY}%`
      this.$el.querySelector('.zoomed-image').style.backgroundPosition = `${percentX}% ${percentY}%`
    },
    handleLeave() {
      const zoomedImage = this.$el.querySelector('.zoomed-image')
      zoomedImage.style.backgroundSize = 'contain'
      zoomedImage.style.backgroundPosition = 'center center'
    }
  }
}
</script>

<style scoped lang="scss">
.zoom-container {
  overflow: hidden;
  position: relative;
}

.zoomed-image {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  transition: background-size 0.3s ease;
}
</style>
